// utils/matchPhotos.js

import { getApiUrl } from "../lib/api";

/**
 * Calls the /api/match endpoint to match user-uploaded photos to listing covers.
 *
 * @param {Object} params
 * @param {Array} params.listings - Array of { id, coverImageUrl }
 * @param {Array} params.photos - Array of { url, createTime }
 * @returns {Promise<{ matches: Record<string, string[]>, unmatchedPhotos: string[] }> }
 */
export async function matchPhotos({ listings, photos }) {
  const res = await fetch(getApiUrl("/api/match"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ listings, photos }),
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Matcher error: ${text}`);
  }

  return await res.json(); // { matches, unmatchedPhotos }
}
